export default function getChangedValueReduxUtil (instanceOrPojo, key) {
  const hasProperty = instanceOrPojo?.changed && (
    Object.prototype.hasOwnProperty.call(instanceOrPojo?.changed, key)
  )
  if (!hasProperty) {
    return
  }
  return instanceOrPojo?.changed[key]
}
